export const signatureDefaultValues = {
  requiredSignatures: "collaborator",
  eSignatureFile: undefined
} as const;
